var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8632 18.063C10.8632 18.3645 10.983 18.6536 11.1962 18.8668C11.4094 19.08 11.6985 19.1998 12 19.1998C12.3016 19.1998 12.5907 19.08 12.8039 18.8668C13.0171 18.6536 13.1369 18.3645 13.1369 18.063V13.1366H18.0632C18.3647 13.1366 18.6539 13.0169 18.8671 12.8037C19.0803 12.5905 19.2 12.3013 19.2 11.9998C19.2 11.6983 19.0803 11.4091 18.8671 11.1959C18.6539 10.9827 18.3647 10.863 18.0632 10.863H13.1369V5.93665C13.1369 5.63514 13.0171 5.34598 12.8039 5.13278C12.5907 4.91958 12.3016 4.7998 12 4.7998C11.6985 4.7998 11.4094 4.91958 11.1962 5.13278C10.983 5.34598 10.8632 5.63514 10.8632 5.93665V10.863H5.93689C5.63538 10.863 5.34622 10.9827 5.13302 11.1959C4.91982 11.4091 4.80005 11.6983 4.80005 11.9998C4.80005 12.3013 4.91982 12.5905 5.13302 12.8037C5.34622 13.0169 5.63538 13.1366 5.93689 13.1366H10.8632V18.063Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.352dfa81.svg";
export { ForwardRef as ReactComponent };